import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';

export class ScriptContext {
    #coords: CoordinatorService;
    startTime: Temporal.Instant;
    args: { [tag: string]: any };

    constructor(coords: CoordinatorService, params?: { [tag: string]: any }) {
        this.#coords = coords;
        this.startTime = Temporal.Instant.fromEpochMilliseconds(Date.now());
        this.args = params || {};

        return new Proxy(this, {
            get(target, prop) {
                if (prop in target) {
                    const value = target[prop as keyof typeof target];
                    // Ensure methods are bound to the instance
                    if (typeof value === 'function') {
                        return value.bind(target);
                    }
                    return value;
                } else if (prop in target.args) {
                    return target.args[prop as string];
                }
            },
            set(target, prop, value) {
                if (prop in target) {
                    (target as any)[prop] = value;
                } else {
                    target.args[prop as string] = value;
                }
                return true;
            },
        });
    }

    get currentItem() {
        return this.#coords.resultList$.activeItem
            ? this.#coords.resultList$.activeItem.scriptClass
            : null;
    }

    get project() {
        return this.#coords.project$.current?.scriptClass;
    }

    get stage() {
        return this.#coords.stage$.current.scriptClass;
    }

    elapsedSeconds() {
        return this.#coords.script$.now().since(this.startTime).total({ unit: 'seconds' });
    }
}
